import firstImage from 'App/assets/tutorialCandidate/1.png';
import secondImage from 'App/assets/tutorialCandidate/2.png';
import thirdImage from 'App/assets/tutorialCandidate/3.png';
import fourthImage from 'App/assets/tutorialCandidate/4.png';
import fifthImage from 'App/assets/tutorialCandidate/5.png';

export const tutorialCandidateSteps = [
	{
		title: '¡Bienvenido a la sección de candidatos!',
		description:
			'Lleva el control de los exámenes  de ingreso de los candidatos de tu empresa',
		img: {
			src: firstImage,
			width: 320,
			heigth: 320,
		},
	},
	{
		title: 'Gestiona la aptitud de los candidatos',
		description: `Visualiza la aptitud laboral de tus candidatos determinada por el médico desde la plataforma.`,
		img: {
			src: secondImage,
			width: 320,
			heigth: 320,
		},
	},
	{
		title: 'Asigna las fechas de las citas de tus candidatos',
		description:
			'Controla las citas de las valoraciones médicas y los exámenes de laboratorio necesarios para tus candidatos.',
		img: {
			src: thirdImage,
			width: 320,
			heigth: 320,
		},
	},
	{
		title: 'Exámenes de ingreso por puesto de trabajo',
		description:
			'Crea los perfiles de puestos, y solicita exámenes de laboratorio específicos para cada uno.',
		img: {
			src: fourthImage,
			width: 320,
			heigth: 320,
		},
	},
	{
		title: 'Red de laboratorios con cobertura nacional',
		description:
			'Tus candidatos recibirán las indicaciones para realizar sus exámenes en nuestra red de laboratorios a nivel nacional.',
		img: {
			src: fifthImage,
			width: 320,
			heigth: 320,
		},
	},
];
